<template>
  <v-app>
    <v-alert
      v-model="alertStatus"
      dismissible
      type="success"
    >Success. Your catalog should arrive within the next week.</v-alert>
    <v-container grid-list-xl>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-text-field v-model="data.company" append-icon="edit" label="Company"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.name"
            v-validate="'required|max:20'"
            append-icon="edit"
            :error-messages="errors.collect('name')"
            data-vv-name="name"
            required
            label="Full Name"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-select v-model="data.country" :items="countries" label="Country"></v-select>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-select
            v-model="data.region"
            v-validate="'required'"
            :error-messages="errors.collect('region')"
            data-vv-name="region"
            require
            :items="regions"
            label="State"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.address1"
            v-validate="'required|max:50'"
            append-icon="book"
            :error-messages="errors.collect('address1')"
            data-vv-name="address1"
            required
            label="Address 1"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="data.address1 != ''" xs12 sm6 d-flex>
          <v-text-field
            v-model="data.address2"
            v-validate="'max:50'"
            append-icon="book"
            :error-messages="errors.collect('address2')"
            data-vv-name="address2"
            label="Address 2"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.city"
            v-validate="'required|max:20'"
            append-icon="edit"
            :error-messages="errors.collect('city')"
            data-vv-name="city"
            required
            label="City"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 d-flex>
          <v-text-field
            v-model="data.zip"
            v-validate="{regex: /^([0-9]{5}$)|(([ABC][0-9]){3})$/}"
            append-icon="edit"
            :error-messages="errors.collect('zip')"
            data-vv-name="zip"
            required
            label="Zip/Postal Code"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm4 d-flex>
          <v-text-field
            v-model="data.email"
            v-validate="'email'"
            append-icon="email"
            :error-messages="errors.collect('email')"
            label="Email"
            data-vv-name="email"
            required
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm4 d-flex>
          <v-checkbox v-model="data.subscribe" label="Subscribe to Email List"></v-checkbox>
        </v-flex>
        <v-flex v-if="data.email != ''" xs12 sm4 d-flex>
          <v-text-field
            v-model="data.phone"
            v-validate="'max:20'"
            append-icon="edit"
            :error-messages="errors.collect('phone')"
            data-vv-name="phone"
            label="Phone"
          ></v-text-field>
        </v-flex>
        <v-flex v-if="data.email == ''" xs12 sm4 d-flex>
          <v-text-field
            v-model="data.phone"
            v-validate="'required|max:20'"
            append-icon="edit"
            :error-messages="errors.collect('phone')"
            data-vv-name="phone"
            required
            label="Phone"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm12 d-flex>
          <v-autocomplete
            v-bind:items="interestsList"
            v-model="data.interests"
            label="Interests"            
            ref="interests"
            :append-icon-cb="closeInterests"
            multiple
            chips
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                close
                @input="data.parent.selectItem(data.item)"
                :selected="data.selected"
                class="chip--select-multi"
                :key="JSON.stringify(data.item)"
              >
               {{ data.item }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>

      <v-layout wrap align-center>
        <v-flex xs12 sm6 d-flex>
          <v-autocomplete
            v-bind:items="hearList"
            v-model="data.hear"
            label="How did you hear about Kencove?"
            ref="hear"
            :append-icon-cb="closeHear"
            multiple
            chips
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                close
                @input="data.parent.selectItem(data.item)"
                :selected="data.selected"
                class="chip--select-multi"
                :key="JSON.stringify(data.item)"
              >
               {{ data.item }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
        
        <v-flex xs12 sm6 d-flex>
          <v-text-field v-model="data.which" append-icon="edit" label="Which one?"></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout wrap align-center>
        <v-flex xs12 sm12 d-flex>
          <v-textarea
            name="input-3-1"
            label="Additional product information?"
            append-icon="note"
            v-model="data.additional"
          ></v-textarea>
        </v-flex>
      </v-layout>

      <vue-recaptcha sitekey="6LdddXsUAAAAAGHumerT5AvTLmu3ruDnZFCuY8M8">
        <v-btn color="primary" dark @click.prevent="submitForm2">Order Catalog</v-btn>
      </vue-recaptcha>
    </v-container>
  </v-app>
</template>


<script>
import { mapGetters } from "vuex";
import VueRecaptcha from "vue-recaptcha";
export default {
  name: "form2",
  components: { VueRecaptcha },
  $_veeValidate: {
    validator: "new"
  },
  computed: {
    ...mapGetters({
      interestsList: "interestsList"
    })
  },
  data: () => ({
    data: {
      email: "",
      company: "",
      name: "",
      address1: "",
      address2: "",
      city: "",
      zip: "",
      subscribe: true,
      phone: "",
      interests: [],
      hear: [],
      which: "",
      additional: "",
      country: "United States",
      region: "Barbuda"
    },
    regions: [
      "Alabama",
      "Alaska",
      "American Samoa",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "District of Columbia",
      "Federated States of Micronesia",
      "Florida",
      "Georgia",
      "Guam",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Marshall Islands",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Northern Mariana Islands",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Palau",
      "Pennsylvania",
      "Puerto Rico",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virgin Island",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming"
    ],
    countries: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor L'Este",
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],
    hearList: ["Search Engine", "Advertisement", "Farm Show", "Other"],
    alertStatus: false,
  }),
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },
  methods: {
    submitForm2() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.alertStatus = this.$store.dispatch("submitForm2", this.data);
        }
      });
    },
    closeHear () {
      if(this.$refs.hear.isMenuActive == true) this.$refs.hear.isMenuActive = false;
    },
    closeInterests () {
      if(this.$refs.interests.isMenuActive == true) this.$refs.interests.isMenuActive = false;
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// catalog_request_form.vue?0ac1c8dc